import React from "react";
import { withTranslation } from "react-i18next";
import { Comment, List } from "antd";
import moment from 'moment';
import { get } from 'lodash';

const dateFormat = 'YYYY-MM-DD HH:mm';

class CommentList extends React.Component {
    render() {
        const { comments, t } = this.props;

        return (
            <div>
                {
                    comments && comments.length > 0 ?
                        <List
                            dataSource={comments}
                            header={`${comments.length} ${comments.length > 1 ? t('comments.comment_list.comments', "comments") : t('comments.comment_list.comment', "comment")}`}
                            itemLayout="horizontal"
                            renderItem={item => (
                                <Comment
                                    author={<a>{get(item, 'commented_by.first_name')} {get(item, 'commented_by.last_name')}</a>}
                                    content={item.comment}
                                    datetime={moment(item.commented_on).format(dateFormat)}
                                />
                            )
                            }
                        /> :
                        ''
                }
            </div>
        );
    }
}


export default withTranslation()(CommentList);


// WEBPACK FOOTER //
// ./src/containers/Comments/CommentList.js